var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2039 2039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1352.81,762.51l-78-78L919.1,1040.18l78,78ZM966.86,1136l-65.76-65.76-45,109.88Zm434-373.49-24,24-316.79,316.8-.19-.19-53.78,53.79-199,79.28-7.49-7.48,81-198L934,977.33l-.07-.08,316.8-316.79,24-24,29.29-29.29a46.15,46.15,0,0,1,65.13,0l61,61a46.14,46.14,0,0,1,0,65.12Zm-102.05-102,78,78,29.29-29.29a12.14,12.14,0,0,0,0-17.06l-61-61a12.13,12.13,0,0,0-17.05,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M653.92,677.43h402.47v34H653.92A23.66,23.66,0,0,0,630.37,735v651.81a23.66,23.66,0,0,0,23.55,23.55h651.81a23.68,23.68,0,0,0,23.56-23.55V976h34v410.74a57.67,57.67,0,0,1-57.55,57.54H653.92a57.67,57.67,0,0,1-57.54-57.54V735a57.67,57.67,0,0,1,57.54-57.54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6b008340.svg";
export { ForwardRef as ReactComponent };